import { brandAndCountryFromZone, type Zone } from '@seek/audience-zones';
import type { Brand } from '@seek/melways-sites';
import { logger } from 'src/modules/logger';
import { logErrorToRaygun } from 'src/modules/raygun-logger';

export const getBrandFromZone = (zone: Zone): Brand => {
  if (!zone) {
    const invalidZoneErrorLogMessage =
      'Invalid zone - Unable to get brand from zone. Fallback to "seek" brand.';

    logger.error({ zone }, invalidZoneErrorLogMessage);
    logErrorToRaygun({
      error: new Error(invalidZoneErrorLogMessage),
      customData: { zone },
    });
  }

  const [brand] = brandAndCountryFromZone(zone || 'anz-1') || ['seek'];

  return brand as Brand;
};
